export const getNeighborhoodPolygon = async (fid, token) => {
  try {
    const params = new URLSearchParams()
    params.append('fid', fid)

    const headers = {
      accept: 'application/json',
    }
    if (token) {
      headers.authorization = `Bearer ${token}`
    }

    const api = await fetch(`/api/get-neighborhood-polygon?${params.toString()}`, {
      method: 'GET',
      headers,
    })

    const response = await api.json()
    return response.neighborhood
  } catch (error) {
    console.log('Could not fetch neighborhood polygon', error) // eslint-disable-line no-console
  }
}
